import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { BodyM } from '@sorare/core/src/atoms/typography';
import {
  DrukWide24,
  DrukWide40,
  MarketingText20,
  Romie20,
} from '@sorare/core/src/components/marketing/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { steps } from './data';

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--double-and-a-half-unit);
  @media ${tabletAndAbove} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: var(--quadruple-unit);
    grid-row-gap: var(--quadruple-unit);
  }
`;

const Subtitle = styled(BodyM)`
  text-transform: uppercase;
`;

const Earn = styled.div`
  display: flex;
  grid-column: 3/4;
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background-color: var(--c-nd-800-opaque);
  padding: var(--double-unit);
  gap: calc(3 * var(--double-and-a-half-unit));
  height: 100%;

  @media ${tabletAndAbove} {
    padding: var(--triple-unit);
  }
`;

type Step = {
  name: string;
  title: ReactNode;
  subtitle: ReactNode;
};

const Step = ({ step: { title, subtitle, name } }: { step: Step }) => (
  <Item>
    <DrukWide40 color="var(--c-black)">{name}</DrukWide40>
    <div>
      <Romie20 color="var(--c-black)">{title}</Romie20>
      <BodyM color="var(--c-nd-400-opaque)">{subtitle}</BodyM>
    </div>
  </Item>
);

export const Steps = () => {
  return (
    <Grid>
      <div>
        <DrukWide24 color="var(--c-pink-600)">
          <FormattedMessage
            id="affiliateProgram.steps.title"
            defaultMessage="How it works"
          />
        </DrukWide24>
        <Subtitle color="var(--c-black)">Sorare</Subtitle>
      </div>
      <Earn>
        <MarketingText20>
          <FormattedMessage
            id="affiliateProgram.steps.helper"
            defaultMessage="Earn up to 10% commissions by promoting Sorare"
          />
        </MarketingText20>
      </Earn>
      {steps.map(step => (
        <Step key={step.name} step={step} />
      ))}
    </Grid>
  );
};
